export const countries = [
  {name:'Chile',
    map: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3336.3025235649066!2d-70.75128868481187!3d-33.258571480829275!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x9662be90fa0a9191%3A0xe01e687545756f2d!2sMecano%20Tubos%20Chile!5e0!3m2!1sen!2sus!4v1567709538553!5m2!1sen!2sus" 
}, 
{name:'Peru',
map:'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3900.8073496539932!2d-77.02726208518662!3d-12.125330091415018!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x9105c95f1506c427%3A0xaf05f6615b6b091a!2sAv.%20Alfredo%20Benavides%20768%2C%20Miraflores%2015047%2C%20Peru!5e0!3m2!1sen!2sus!4v1567737782390!5m2!1sen!2sus'
}, 
]
